export const getCurrencySymbol = (country) => {
  const c = String(country || '').trim().toLowerCase();
  if (c === 'india' || c === 'in' || c === 'inr') {
    return '₹';
  }
  return '$'; // Default to USD
};

export const formatCurrency = (amount, country) => {
  const selectedCountry = country || sessionStorage.getItem('companyCountry') || 'USA';
  const symbol = getCurrencySymbol(selectedCountry);
  const numericAmount = Number(amount || 0);

  if (symbol === '₹') {
    return symbol + numericAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  return symbol + numericAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
